<template>
  <div>
    <v-textarea :label="$t('views.InsertMap.jsonLabel')" outlined v-model="json" class="ma-5" />
    <v-text-field :label="$t('views.InsertMap.pathLabel')" outlined v-model="path" class="ma-5"/>
    <v-text-field :label="$t('views.InsertMap.fieldLabel')" outlined v-model="field" class="ma-5"/>
    <v-btn small color="primary" class="ma-5" @click="insertMapMethod">{{ $t('views.InsertMap.insert') }}</v-btn>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
export default {
  data () {
    return {
      json: '',
      path: '',
      field: ''
    }
  },
  methods: {
    ...mapActions('admin', [
      'insertMap'
    ]),
    insertMapMethod: function () {
      this.insertMap({
        json: this.json,
        path: this.path,
        field: this.field
      })
    }
  }
}
</script>
